import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import FlightClass from '../entities/flight/flightClass';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';

interface FlightClassState extends ListState<FlightClass> {
  flightClass: FlightClass;
  editFlightClass: FlightClass;
}

class FlightClassMutations extends ListMutations<FlightClass> {}

class FlightClassModule extends ListModule<FlightClassState, any, FlightClass> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<FlightClass>(),
    loading: false,
    editFlightClass: new FlightClass(),
    selectFlightClass: new FlightClass(),
  };
  actions = {
    async selectFlightClass(
      context: ActionContext<FlightClassState, any>,
      payload: any
    ) {
      context.state.editFlightClass = payload.data;
    },

    async saveFlightClass(
      context: ActionContext<FlightClassState, any>,
      payload: any
    ) {
      let reponse = await Ajax.post(
        '/api/services/app/Flight/SaveFlightClass',
        payload.data
      );

      let page = reponse.data.result as PageResult<FlightClass>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async updateFlightClass(
      context: ActionContext<FlightClassState, any>,
      payload: any
    ) {
      let reponse = await Ajax.put(
        '/api/services/app/Flight/UpdateFlightClass',
        payload.data
      );

      let page = reponse.data.result as PageResult<FlightClass>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getFlightClasses(
      context: ActionContext<FlightClassState, any>,
      payload: any
    ) {
      // context.state.loading=true;
      let reponse = await Ajax.get(
        '/api/services/app/Flight/GetFlightClasses',
        payload.data
      );

      // context.state.loading=false;
      let page = reponse.data.result as PageResult<FlightClass>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async deleteFlightClass(
      context: ActionContext<FlightClassState, any>,
      payload: any
    ) {
      await Ajax.delete(
        '/api/services/app/Flight/DeleteFlightClass?input=' + payload.payload
      );
    },
  };
  mutations = {
    setCurrentPage(state: FlightClassState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: FlightClassState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const flightClassModule = new FlightClassModule();
export default flightClassModule;
